/**
 * Health Insurance tab — extracted policy cards only.
 * Uploads now live on the dedicated Upload tab.
 */
import { Card, CardContent, Skeleton } from '@finmin/ui';
import { HeartOff } from 'lucide-react';
import { useExtractedProfile } from '@/api/profile-documents';
import { HealthPolicyCard } from '@/features/insurance/health-policy-card';

export function HealthInsuranceTab() {
  const { data, isLoading } = useExtractedProfile();
  const policies = data?.health_insurance_policies ?? [];

  if (isLoading) {
    return <Skeleton className="h-64 w-full rounded-xl" />;
  }
  if (policies.length === 0) {
    return <EmptyState />;
  }
  return (
    <div className="space-y-5">
      {policies.map((p) => (
        <HealthPolicyCard key={p.id} policy={p} />
      ))}
    </div>
  );
}

function EmptyState() {
  return (
    <Card>
      <CardContent className="py-10 text-center">
        <HeartOff
          className="mx-auto h-10 w-10 text-muted-foreground/60"
          aria-hidden
        />
        <p className="mt-3 text-sm font-medium text-foreground">
          No health insurance policies yet
        </p>
        <p className="mt-1 text-xs text-muted-foreground">
          Head to the <span className="font-medium text-foreground">Upload Documents</span>{' '}
          tab to add a policy PDF. We'll process it and surface the cover,
          insured members, and claim contacts here.
        </p>
      </CardContent>
    </Card>
  );
}
